/**
 * Mobile build target helpers.
 *
 * The web build leaves REACT_APP_BUILD_TARGET unset, so isMobileBuild() is false
 * and nothing changes for web users. The Capacitor mobile build sets it to
 * 'mobile' to (a) hide digital-goods Stripe checkouts (app-store compliance) and
 * (b) activate the Welcome Back interstitial.
 *
 * A localStorage override ('forceMobileBuild' = '1') is supported purely for QA
 * so the mobile experience can be previewed on a web build without rebuilding.
 */
export const isMobileBuild = () => {
  if (process.env.REACT_APP_BUILD_TARGET === 'mobile') return true;
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem('forceMobileBuild') === '1';
  } catch (e) {
    return false;
  }
};

/** Public website base URL that mobile "upgrade on web" links point to. */
export const getWebUrl = () => process.env.REACT_APP_WEB_URL || '';

/** Build an absolute web URL for a given path (e.g. '/dashboard/modules'). */
export const webUrl = (path = '') => {
  const base = getWebUrl().replace(/\/$/, '');
  if (!base) return '#';
  return `${base}${path}`;
};
